import { render, staticRenderFns } from "./emp-card.vue?vue&type=template&id=231d2df6&scoped=true"
import script from "./emp-card.vue?vue&type=script&lang=js"
export * from "./emp-card.vue?vue&type=script&lang=js"
import style0 from "./emp-card.vue?vue&type=style&index=0&id=231d2df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d2df6",
  null
  
)

export default component.exports